import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d47b62c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "px-3 menu-link-group" }
const _hoisted_2 = {
  key: 0,
  class: "text-mild text-size-14 text-weight-500"
}
const _hoisted_3 = { class: "bg-white border border-outline-color px-3 round-4" }


export default /*#__PURE__*/_defineComponent({
  __name: 'MenuLinkGroup',
  props: {
  label: {
    type: String,
    required: false
  }
},
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (props.label)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(props.label), 1))
      : _createCommentVNode("", true),
    _createTextVNode(),
    _createElementVNode("div", _hoisted_3, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})